import { useState } from 'react';

import { DialogNugget, PanelNugget } from '@backrs_ui/common-ui';

import { handleBookmark } from '@backrs_ui/grow-ui/src/components/Nuggets/nugget.util';
import { LubavPost } from '@backrs_ui/grow-ui/src/models/models';
import { useAppSelector, useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectBookmarkedNuggetId } from '@backrs_ui/grow-ui/src/redux/user/user';

import { Box, Dialog } from '@mui/material';

import { commonStyles } from './CommonStyles';

const PROSPER_URL = process.env.REACT_APP_GROW_URL;
const BACKRS_URL = process.env.REACT_APP_BACKRS_URL;

type PostsFormatterProps = Readonly<{
  posts: LubavPost[];
}>;

export const PostsFormatter = ({ posts }: PostsFormatterProps) => {
  const [open, setOpen] = useState(false);
  const [activeDialogPostNugget, setActiveDialogPostNugget] = useState<LubavPost | null>(null);

  const bookmarkId = useAppSelector(
    selectBookmarkedNuggetId({
      nuggetId: Number(activeDialogPostNugget?.id),
      variant: 'post',
    }),
  );

  const dispatch = useAppDispatch();

  const dialogNugget = activeDialogPostNugget ? (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
      <DialogNugget
        shareParams={
          PROSPER_URL
            ? {
                title: `Prosper: ${activeDialogPostNugget.metadata?.author}'s Thread`,
                text: `Prosper: ${activeDialogPostNugget.relevance}`,
                url: `${PROSPER_URL}?post=${activeDialogPostNugget.id}`,
              }
            : undefined
        }
        title={`${activeDialogPostNugget.metadata?.author || ''}'s Thread`}
        description={activeDialogPostNugget?.relevance}
        variant={{
          type: 'post',
          text: activeDialogPostNugget?.quote,
          headshotImg: activeDialogPostNugget?.metadata.author_profile_picture,
          userAbbreviatedName: activeDialogPostNugget?.metadata.author,
          postDate: activeDialogPostNugget?.metadata.created_at,
          postUrl: activeDialogPostNugget?.id
            ? `${BACKRS_URL}/posts/${activeDialogPostNugget.id}/comments`
            : undefined,
        }}
        columnCategory={'Community'}
        saveToLibrary={() =>
          handleBookmark({
            nuggetId: Number(activeDialogPostNugget?.id),
            dispatch,
            bookmarkId,
            variant: 'post',
          })
        }
        hasBookmarkedNugget={!!bookmarkId}
      />
    </Dialog>
  ) : null;

  return (
    <>
      {dialogNugget}
      <Box sx={commonStyles.nuggetList}>
        {posts &&
          posts.map((post) => (
            <PanelNugget
              key={post.id}
              title={`${post.metadata?.author || ''}'s Thread`}
              subText={post.relevance}
              useSplitLayout={true}
              size="SMALL"
              variant={{
                type: 'post',
                text: post.relevance,
                additionalQuote: post.quote,
                additionalQuoteAuthor: post.quote_author,
              }}
              onClick={() => {
                setActiveDialogPostNugget(post);
                setOpen(true);
              }}
            />
          ))}
      </Box>
    </>
  );
};
